const Cafe24InfoPage = () => {
  return <div />;
};

export default Cafe24InfoPage;
